import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from "react-router-dom";
import Login from "./Login";
import AuthProvider from "./AuthProvider";
import PrivateRoute from "./PrivateRoute";
import Dashboard from "./Dashboard";
import LiveViewToTag from "./liveViewToTag";
import { AutodeskAuthProvider } from "./autodesk/AutodeskAuthContext";
import AutodeskCallback from "./autodesk/AutodeskCallback";
import AutodeskProtectedRoute from "./autodesk/AutodeskProtectedRoute";

/** Wraps Datum360 AuthProvider around child routes (Login + PrivateRoute subtree). */
function AuthProviderLayout() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

function App() {
  return (
    <div className="App">
      <Router>
        <AutodeskAuthProvider>
          <Routes>
            <Route path="/auth/callback" element={<AutodeskCallback />} />
            <Route element={<AutodeskProtectedRoute />}>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route element={<AuthProviderLayout />}>
                <Route path="/login" element={<Login />} />
                <Route element={<PrivateRoute />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/liveViewToTag" element={<LiveViewToTag />} />
                </Route>
              </Route>
            </Route>
          </Routes>
        </AutodeskAuthProvider>
      </Router>
    </div>
  );
}

export default App;
